// extracted by mini-css-extract-plugin
module.exports = {"dj-case":"case_dj-case__10Iap","dj-case-center":"case_dj-case-center__OVFww","dj-case-whole":"case_dj-case-whole__2tPz8"};